import {
  DEFAULT_BACKGROUND_EFFECT,
  normalizeBackgroundEffect,
  BACKGROUND_EFFECT_STORAGE_KEY,
} from './backgroundEffects';

/** @returns {import('./backgroundEffects').ArchonBackgroundEffectId} */
export function getStoredBackgroundEffect() {
  try {
    const raw = localStorage.getItem(BACKGROUND_EFFECT_STORAGE_KEY);
    return normalizeBackgroundEffect(raw);
  } catch {
    return DEFAULT_BACKGROUND_EFFECT;
  }
}

/** @param {import('./backgroundEffects').ArchonBackgroundEffectId} effect */
export function setStoredBackgroundEffect(effect) {
  try {
    localStorage.setItem(BACKGROUND_EFFECT_STORAGE_KEY, normalizeBackgroundEffect(effect));
  } catch {
    /* ignore quota / private mode */
  }
}
